'use client';

import React, { JSX, MouseEvent } from 'react';
import Keys from '@/Translations/generated/da/country.json.keys';
import { smoothScroll, THEMES } from '@/Util/globals';
import { useTranslation } from '@/app/i18n/client';

const CountryMainScroll = (): JSX.Element => {
  const { t } = useTranslation('country');

  return (
    <span
      className="country-main__container__link"
      onClick={(e: MouseEvent<HTMLAnchorElement>): void => smoothScroll('productTeaser', e)}
    >
      {t(Keys.moreInformation)} {' >'}
    </span>
  );
};

export default CountryMainScroll;
